import type { GridApi } from 'ag-grid-community';
import { createContext, useContext } from 'react';

export const GridApiContext = createContext<GridApi | undefined | null>(undefined);
export const useGridApiContext = () => {
  return useContext(GridApiContext);
};
